import React, { Component } from 'react'
import { Calendar, Badge } from 'antd';
import { connect } from 'dva'
import moment from 'moment'
import { all } from '../../services/restApi'
import { getTotal } from '../../utils'
import config from '../../utils/config'
import Currency from 'react-currency-formatter';
const _ = require('underscore')

class Dashboard extends Component {

    constructor (props) {
        super(props);

        this.state = {
            daily: [], 
            pending: [],
            hotels: []
        };

        if (localStorage.getItem('currentHotel')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
    }


    /**
    * Inicialización
    */
    componentDidMount () {
        
        let query = {};

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('TourCompany', {where: query, limit: 1000, order: 'name'}).then((resp) => {

            let hotels = [];
            _.map(resp.results, (item, key) => {

                all('Report', {
                    where: {
                        hotel: {__type: 'Pointer', className: 'TourCompany', objectId: item.objectId},
                        month: (new Date().getMonth() + 1).toString(),
                        year: (new Date().getFullYear()).toString()
                    }
                }).then((report) => {

                    item.report = report.results[0];
                    hotels.push(item);

                    if (key === resp.results.length - 1) {
                        setTimeout(function() {
                            this.setState({ hotels: hotels });
                        }.bind(this), 500);
                    }
                });
            });
        })
    }


    getListData (value) {
        let listData;

        switch (value.date()) {
            case 8:
                listData = [
                    { type: 'warning', content: 'This is warning event.' },
                    { type: 'success', content: 'This is usual event.' },
                ]; 
            break;
            case 10:
                listData = [
                    { type: 'warning', content: 'This is warning event.' },
                    { type: 'success', content: 'This is usual event.' },
                    { type: 'error', content: 'This is error event.' },
                ]; 
            break;
            case 15:
                listData = [
                    { type: 'warning', content: 'This is warning event' },
                    { type: 'success', content: 'This is very long usual event。。....' },
                    { type: 'error', content: 'This is error event 1.' },
                    { type: 'error', content: 'This is error event 2.' },
                    { type: 'error', content: 'This is error event 3.' },
                    { type: 'error', content: 'This is error event 4.' },
                ]; 
            break;
            default:
        }

        return listData || [];
    }

    dateCellRender (value) {
        const listData = this.getListData(value);
        
        return (
            <ul className="events">
                {
                    listData.map(item => (
                        <li key={item.content}>
                            <Badge status={item.type} text={item.content} />
                        </li>
                    ))
                }
            </ul>
        );
    }

    getMonthData (value) {
        if (value.month() === 8) {
            return 1394;
        }
    }

    monthCellRender(value) {
        const num = this.getMonthData(value);
        
        return num ? (
            <div className="notes-month">
                <section>{num}</section>
                <span>Backlog number</span>
            </div>
        ) : null;
    }


    /**
    * Render del componente
    */
    render () {

        if (this.props.app.user.type === 'administrador') {
            return (
                <div className="content-wrapper">
                    <section className="content text-center">
                        <h1>BIENVENIDO AL SISTEMA DE TOURS<br />
                        TRIE ADVENTURES</h1>

                        <div className="row marginTop30">
                            <div className="col-md-12">
                                <Calendar mode="month" dateCellRender={this.dateCellRender.bind(this)} monthCellRender={this.monthCellRender.bind(this)} />
                            </div>
                        </div>
                    </section>
                </div>
            )
        } else {
            return (
                <div className="content-wrapper">
                    <section className="content text-center">
                        <h1>BIENVENIDO AL SISTEMA DE TOURS<br />
                        TRIE ADVENTURES</h1>
                    </section>
                </div>
            )
        }
    }
}

export default connect(({Dashboard, app}) => ({Dashboard, app}))(Dashboard)


// WEBPACK FOOTER //
// ./src/components/dashboard/index.js